import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import styles from './PaymentSection.module.css'

interface PaymentSectionProps {
  title: string
  description?: string
  glyph?: IconGlyph
  children?: React.ReactNode
  id?: string
  className?: string
}

export function PaymentSection({
  title,
  description,
  glyph,
  children,
  id,
  className,
}: PaymentSectionProps) {
  return (
    <div className={cn(styles.wrapper, className)} data-qa="payment-section" id={id}>
      {(title || glyph) && (
        <div className={styles.heading}>
          {glyph && <Icon glyph={glyph} size={24} />}
          {title && <h2 className={styles.title}>{title}</h2>}
        </div>
      )}
      {description && (
        <div className={styles.description}>
          <Typography className={styles.descriptionText}>
            {description}
          </Typography>
        </div>
      )}
      {children && (
        <div className={styles.body}>
          {children}
        </div>
      )}
    </div>
  )
}
